/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manageyouraccountpreferencesandsettings5Inputs */

const en_manageyouraccountpreferencesandsettings5 = /** @type {(inputs: Manageyouraccountpreferencesandsettings5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your account preferences and settings`)
};

const de_manageyouraccountpreferencesandsettings5 = /** @type {(inputs: Manageyouraccountpreferencesandsettings5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwalte deine Kontoeinstellungen.`)
};

/**
* | output |
* | --- |
* | "Manage your account preferences and settings" |
*
* @param {Manageyouraccountpreferencesandsettings5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const manageyouraccountpreferencesandsettings5 = /** @type {((inputs?: Manageyouraccountpreferencesandsettings5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manageyouraccountpreferencesandsettings5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_manageyouraccountpreferencesandsettings5(inputs)
	return de_manageyouraccountpreferencesandsettings5(inputs)
});
export { manageyouraccountpreferencesandsettings5 as "manageYourAccountPreferencesAndSettings" }